module.exports = __webpack_public_path__ + "20212ef8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/ClinicaMedica/24579.jpg
// module id = 1316
// module chunks = 0 1